import { render, staticRenderFns } from "./orderReviewScanning.vue?vue&type=template&id=3a8f04aa&scoped=true"
import script from "./orderReviewScanning.vue?vue&type=script&lang=js"
export * from "./orderReviewScanning.vue?vue&type=script&lang=js"
import style0 from "./orderReviewScanning.vue?vue&type=style&index=0&id=3a8f04aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f04aa",
  null
  
)

export default component.exports